module.exports = __webpack_public_path__ + "static/img/weather_009.324c36a4.svg";